// extracted by mini-css-extract-plugin
export default {"dots":"Gallery__dots--hjsWkN","dot":"Gallery__dot--Gom4ng","click":"Gallery__click--cyqeWF","active":"Gallery__active--hIMjTg"};